<template>
    <svg class="wscn-icon" aria-hidden="true">
        <use :xlink:href="iconName"></use>
    </svg>
</template>

<script>
export default {
    name: 'wscn-icon-svg',
    props: {
        iconClass: {
            type: String,
            required: true
        }
    },
    computed: {
        iconName() {
            return `#icon-${this.iconClass}`
        }
    }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// wscn-icon-svg.vue?411373fe